<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb ref="breadcrumb"></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--5">
      <!-- <div class="card mb-4"> -->
        <!-- Card body -->
        <!-- <div class="card-body"> -->
          <b-row>
            <b-col xl="8" class="mb-5 mb-xl-0">
              <card type="default" header-classes="bg-transparent">
                <b-row align-v="center" slot="header">
                  <b-col>
                    <h6 class="text-light text-uppercase ls-1 mb-1">Overview</h6>
                    <h5 class="h3 text-white mb-0">Odometer evolution</h5>
                  </b-col>
                  <b-col>
                    <b-nav class="nav-pills justify-content-end">
                      <b-nav-item class="mr-2 mr-md-0" :active="mileageEvolutionChart.months === 3" link-classes="py-2 px-3"
                        @click.prevent="initMileageEvolutionChart(3)">
                        <span class="d-none d-l-block">3 Months</span>
                        <span class="d-l-none">3M</span>
                      </b-nav-item>
                      <b-nav-item class="mr-2 mr-md-0" :active="mileageEvolutionChart.months === 6" link-classes="py-2 px-3"
                        @click.prevent="initMileageEvolutionChart(6)">
                        <span class="d-none d-l-block">6 Months</span>
                        <span class="d-l-none">6M</span>
                      </b-nav-item>
                      <b-nav-item link-classes="py-2 px-3" :active="mileageEvolutionChart.months === 12"
                        @click.prevent="initMileageEvolutionChart(12)">
                        <span class="d-none d-l-block">Year</span>
                        <span class="d-l-none">1Y</span>
                      </b-nav-item>
                      <b-nav-item class="mr-2 mr-md-0" :active="mileageEvolutionChart.months === 0" link-classes="py-2 px-3"
                        @click.prevent="initMileageEvolutionChart(0)">
                        <span class="d-none d-md-block">All</span>
                        <span class="d-md-none">All</span>
                      </b-nav-item>
                    </b-nav>
                  </b-col>
                </b-row>
                <line-chart :height="350" ref="mileageEvolutionChart" :chart-data="mileageEvolutionChart.chartData"
                  :extra-options="mileageEvolutionChart.extraOptions">
                </line-chart>
              </card>
            </b-col>
            <b-col xl="4" class="mb-5 mb-xl-0">
              <card header-classes="bg-transparent">
                <b-row align-v="center" slot="header">
                  <b-col>
                    <h6 class="text-uppercase text-muted ls-1 mb-1">By month</h6>
                    <h5 class="h3 mb-0">Mileage</h5>
                  </b-col>
                </b-row>
            
                <bar-chart :height="350" ref="mileageByMonthChart" :chart-data="mileageByMonthChart.chartData">
                </bar-chart>
              </card>
            </b-col>
          </b-row>
        <!-- </div> -->
      <!-- </div> -->
    </b-container>
  </div>
</template>
<script>
  import * as chartConfigs from '@/components/Charts/config';
  import BarChart from '@/components/Charts/BarChart';
  import LineChart from '@/components/Charts/LineChart';
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import { mapActions, mapGetters } from 'vuex';
  import MetricsAPI from '../../api/metrics'
  import moment from 'moment';
  import _ from 'lodash'
  window.moment = moment

  export default {
    name: 'starter-page',
    components: {
      BarChart,
      LineChart,
      RouteBreadCrumb
    },
    data() {
      return {
        mileageEvolutionChart: {
          allData: {},
          months: 3,
          chartData: {
            datasets: [
              {
                label: 'Odometer',
                data: [],
              }
            ],
            labels: [],
          },
          extraOptions: chartConfigs.blueChartOptions,
        },
        mileageByMonthChart: {
          allData: {},
          months: 3,
          chartData: {
            datasets: [
              {
                label: 'Odometer',
                data: [],
              }
            ],
            labels: [],
          },
          extraOptions: chartConfigs.blueChartOptions,
        }
      }
    },
    async mounted() {
      await this.listMotorbikes()
      this.$route.matched[this.$route.matched.length - 2].meta.breadcrumbTitle = this.motorbike._name
      this.$route.matched[this.$route.matched.length - 2].params = { id: this.motorbike._id }
      this.$refs.breadcrumb.update()
      this.fetchMotorbikesOdometerEvolution()
    },
    methods: {
      ...mapActions({
        listMotorbikes: 'motorbikes/fetch',
      }),
      initMileageEvolutionChart(months) {
        const pointsByMotorbike = this.mileageEvolutionChart.allData.map(m => {
          return {
            motorbike: m,
            odometerPoints: m.odometerPoints.filter(p => p.date)
          }
        })
        const firstDate = pointsByMotorbike[0].odometerPoints[0] && pointsByMotorbike[0].odometerPoints[0].date && moment(pointsByMotorbike[0].odometerPoints[0].date)
        const fromDate = months === 0 ? firstDate : moment().add(-months, 'months')
        const labels = []
        for (let i = 0; i < moment().diff(firstDate, 'months') + 2; i++) {
          labels.push(moment(firstDate).add(i, 'months').format('MMM YY'))
        }
        let pointsByMonth = pointsByMotorbike.map(m => {
          return {
            label: 'Odometer',
            data: labels.map(date => {
              const last = _.last(m.odometerPoints.filter(p => moment(p.date).format('MMM YY') === date))
              return last && last.km || 0
            })
          }
        })
        pointsByMonth[0].data.forEach((km, i) => {
          if (km === 0 && i != 0) pointsByMonth[0].data[i] = pointsByMonth[0].data[i-1]
        })
        pointsByMonth[0].data = _.takeRight(pointsByMonth[0].data, moment().diff(fromDate, 'months'))

        this.mileageEvolutionChart.chartData = {
          datasets: pointsByMonth,
          labels: _.takeRight(labels, moment().diff(fromDate, 'months'))
        }
        this.mileageEvolutionChart.months = months;
      },
      initMileageByMonthChart() {
        const pointsByMotorbike = this.mileageEvolutionChart.allData.map(m => {
          return {
            motorbike: m,
            odometerPoints: m.odometerPoints.filter(p => p.date)
          }
        })
        const firstDate = pointsByMotorbike[0].odometerPoints[0] && pointsByMotorbike[0].odometerPoints[0].date && moment(pointsByMotorbike[0].odometerPoints[0].date)
        const labels = []
        for (let i = 0; i < moment().diff(firstDate, 'months') + 2; i++) {
          labels.push(moment(firstDate).add(i, 'months').format('MMM YY'))
        }
        let pointsByMonth = pointsByMotorbike.map(m => {
          return {
            label: 'Odometer',
            data: labels.map(date => {
              const last = _.last(m.odometerPoints.filter(p => moment(p.date).format('MMM YY') === date))
              return last && last.km || 0
            })
          }
        })
        pointsByMonth[0].data.forEach((km, i) => {
          if (km === 0 && i != 0) pointsByMonth[0].data[i] = pointsByMonth[0].data[i - 1]
        })
        const data = pointsByMonth[0].data.reverse()
        let diff = data.map((val, i) => Number((val - data[i + 1] || 0).toFixed(3))).reverse()
        this.mileageByMonthChart.chartData = {
          datasets: [{ label: 'Mileage', data: _.takeRight(diff, 6) }],
          labels: _.takeRight(labels, 6)
        }
      },
      fetchMotorbikesOdometerEvolution() {
        MetricsAPI.motorbikesOdometerEvolution({ motorbike: this.motorbike._id })
          .then(metric => {
            this.mileageEvolutionChart.allData = metric
            this.initMileageEvolutionChart(3)
            this.initMileageByMonthChart()
          })
      }
    },
    computed: {
      ...mapGetters({
        motorbikes: 'motorbikes/motorbikes'
      }),
      motorbike() {
        return this.motorbikes.find(m => m._id === this.$route.params.id)
      }
    }
  };
</script>
<style scoped>
  .starter-page {
    min-height: calc(100vh - 380px);
  }
  .dropdown {
    z-index: 1000;
  }
</style>
